import $http from '@/libs/axios'

class TiersAPIs {
  static async getList() {
    return (await $http.get('/marketing/tiers/list')).data
  }

  static async process(body: any) {
    return (await $http.post('/marketing/tiers/process', body)).data
  }
}

export default TiersAPIs
